import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { ColumnChooserModel } from '../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../models/common/ColumnFilterModel';

/** Ayarlar > Otomatik Faturalama (22.10.2026): kurallar, önizleme, elle çalıştırma, çalışma geçmişi ve onay. */

export const OTOMATIK_FATURA_SAYFASI = 'Ayarlar > Otomatik Faturalama';

export const KURAL_TURLERI = [
    { value: 1, label: 'Nakliye · Aylık sabit gelir' },
    { value: 3, label: 'Nakliye · Dönemsel' },
    { value: 2, label: 'Yurtiçi Kargo · Dönemsel' },
];

export const DONEMLER = [
    { value: 1, label: 'Önceki ay' },
    { value: 2, label: 'Önceki hafta (pazartesi–pazar)' },
    { value: 3, label: 'Önceki gün' },
    { value: 4, label: 'Bu hafta (bugüne kadar)' },
    { value: 5, label: 'Bu ay (bugüne kadar)' },
];

export const FATURA_TARIHLERI = [
    { value: 1, label: 'Çalıştığı gün' },
    { value: 2, label: 'Dönemin son günü' },
];

export const GONDERIMLER = [
    { value: 1, label: "Yalnız Keylogx'te", aciklama: "Fatura oluşur, Uyumsoft'a gönderilmez. Kontrol edip elle gönderilir." },
    { value: 2, label: "Uyumsoft'a taslak", aciklama: "Uyumsoft'ta taslak olarak bekler; GİB'e Keylogx'ten ya da Uyumsoft'tan gönderilir." },
    { value: 3, label: "GİB'e gönder", aciklama: "Onaydan sonra (onay açıksa) e-Fatura / e-Arşiv olarak kesilir." },
];

export const SABIT_GELIR_SECENEKLERI = [
    { value: '', label: 'Kira ve personel' },
    { value: '1', label: 'Yalnız kira' },
    { value: '2', label: 'Yalnız personel' },
];

export const GRUPLAMA_ALANLARI = [
    { value: 'BOLUM', label: 'Bölüm' },
    { value: 'PO', label: 'PO' },
    { value: 'PONO', label: 'PO No' },
];

/** Hazır zamanlamalar (Quartz cron: saniye dakika saat gün ay haftagünü). */
export const CRON_SABLONLARI = [
    { value: '0 0 6 1 * ?', label: "Her ayın 1'i 06:00", donem: 1 },
    { value: '0 0 8 ? * MON', label: 'Her pazartesi 08:00', donem: 2 },
    { value: '0 0 7 * * ?', label: 'Her gün 07:00', donem: 3 },
];

export interface OtomatikFaturaListIstegi {
    searchTerm: string
    skip: number
    take: number
    currentPage: number
    columnChooser: ColumnChooserModel[] | undefined
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
    ids?: string[]
    kuralId?: string
}

export const ilkOtomatikFaturaListIstegi: OtomatikFaturaListIstegi = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    columnChooser: undefined,
    columnFilters: []
}

export interface OtomatikFaturaKurali {
    otomatikFaturaKuraliId: string
    ad: string
    kuralTuru: number
    kuralTuruAdi: string
    modulAdi?: string | null
    isCustomActive: boolean
    cron: string
    baslangicTarihi?: string | null
    bitisTarihi?: string | null
    donem: number
    donemAdi: string
    faturaTarihi: number
    faturaTarihiAdi: string
    musteriIdleri: string[]
    musteriler?: string | null
    poNumaralari: string[]
    poNumaralariAdi?: string | null
    sabitGelirTuru?: number | null
    gruplama: string[]
    gruplamaAdi?: string | null
    hizmetGrupla: boolean
    /** Dönemsel: hafta iki aya yayılırsa ay bazında ayrı fatura; önceki ay parçası ayın son günü tarihli (25.10.2026) */
    aySonundaBol: boolean
    gonderim: number
    gonderimAdi: string
    onayGerekli: boolean
    onaylayiciUserId?: string | null
    onaylayiciAdi?: string | null
    hatirlatmaDakika: number
    hatirlatmaBaslangicSaati: number
    hatirlatmaBitisSaati: number
    bilgiAlicilari?: string | null
    sonrakiCalismaStr?: string | null
    sonCalismaStr?: string | null
    sonDurumAdi?: string | null
    isSelected?: boolean
}

export interface OtomatikFaturaKuralKaydet {
    id?: string
    ad?: string
    kuralTuru: number
    isCustomActive: boolean
    cron?: string
    baslangicTarihi?: string
    bitisTarihi?: string
    donem: number
    faturaTarihi: number
    musteriIdleri: string[]
    poNumaralari: string[]
    sabitGelirTuru?: number
    gruplama: string[]
    hizmetGrupla: boolean
    /** Dönemsel: hafta iki aya yayılırsa ay bazında ayrı fatura; önceki ay parçası ayın son günü tarihli (25.10.2026) */
    aySonundaBol: boolean
    gonderim: number
    onayGerekli: boolean
    onaylayiciUserId?: string
    hatirlatmaDakika: number
    hatirlatmaBaslangicSaati: number
    hatirlatmaBitisSaati: number
    bilgiAlicilari?: string
}

export interface OtomatikFaturaPlanSatiri {
    grupAnahtari: string
    musteriAdi?: string | null
    poNo?: string | null
    aciklama?: string | null
    /** Faturaya gelecek satırlar (sabit gelir: bölüm / hizmet kalemi + tutar). */
    detaylar?: { bolum?: string | null, kalem?: string | null, tutar: number }[]
    paraBirimi?: string | null
    matrah: number
    kdv: number
    tevkifatli: boolean
    /** Tahmini tevkifat tutari (fatura kuraliyla). */
    tevkifat: number
    /** Brut Tutar: KDV dahil toplam - tevkifat (faturadaki gibi). */
    brut: number
    toplam: number
    not?: string | null
    atlanacak: boolean
    siparisIdleri: string[]
}

export interface OtomatikFaturaOnizleme {
    donemAdi: string
    faturaTarihi: string
    donemBaslangic: string
    donemBitis: string
    satirlar: OtomatikFaturaPlanSatiri[]
    uyarilar: string[]
    mevcutCalismaDurumu?: string | null
    silinenFaturaSayisi: number
    yenidenCalistirilabilir: boolean
    toplam: number
    matrah: number
    kdv: number
    tevkifat: number
    brut: number
}

export interface OtomatikFaturaCalismasi {
    otomatikFaturaCalismasiId: string
    kuralId: string
    kuralAdi?: string | null
    kuralTuruAdi?: string | null
    modulAdi?: string | null
    donemAdi: string
    planlananZamanStr: string
    faturaTarihiStr: string
    tetikleyenAdi: string
    durum: number
    durumAdi: string
    gonderimAdi: string
    onayGerekli: boolean
    onaylayiciAdi?: string | null
    onaylayanAdi?: string | null
    onayZamaniStr?: string | null
    onayKanali?: string | null
    faturaSayisi: number
    hataliSayisi: number
    atlananSayisi: number
    toplam: number
    hatirlatmaSayisi: number
    mesaj?: string | null
    isSelected?: boolean
}

export interface OtomatikFaturaBelgesi {
    id: string
    musteriAdi?: string | null
    poNo?: string | null
    aciklama?: string | null
    siparisSayisi: number
    ambarRefNo?: string | null
    invoiceId?: string | null
    faturaRefNo?: string | null
    faturaNo?: string | null
    paraBirimi?: string | null
    matrah: number
    kdv: number
    tevkifat: number
    toplam: number
    toplamYerel: number
    durum: number
    durumAdi: string
    mesaj?: string | null
}

export interface OtomatikFaturaCalismaDetayi {
    calisma: OtomatikFaturaCalismasi
    belgeler: OtomatikFaturaBelgesi[]
    kayitlar: { zaman: string, seviye: number, mesaj: string }[]
    onaylayabilirMi: boolean
}

/** Çalışma durumları (OtomatikFaturaCalismaDurumu). */
export const CALISMA = { BEKLIYOR: 0, CALISIYOR: 1, ONAY_BEKLIYOR: 2, GONDERILIYOR: 3, TAMAMLANDI: 4, KISMEN_HATALI: 5, HATALI: 6, REDDEDILDI: 7 };

export const durumRengi = (durum: number) => {
    switch (durum) {
        case CALISMA.TAMAMLANDI: return 'success';
        case CALISMA.ONAY_BEKLIYOR: return 'warning';
        case CALISMA.KISMEN_HATALI:
        case CALISMA.HATALI: return 'danger';
        case CALISMA.REDDEDILDI: return 'secondary';
        default: return 'info';
    }
}

/** Bos tarih alani ("") sunucuya "tarih yok" (undefined) olarak gider; "" tarih olarak okunamiyor, istek reddediliyordu. */
export const tarihVeyaBos = (t: string | null | undefined) => (t && t.trim() != '' ? t : undefined);

export const tl = (n: number | null | undefined) => (n ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const cagir = async (yol: string, inputObj: any, gunluk: boolean = true) => {
    try {
        if (gunluk)
            console.log('SERVICE CALL - OtomatikFatura/' + yol, JSON.stringify(inputObj));

        const resp = await axios.post(Helpers.getEndpoint() + '/OtomatikFatura/' + yol, inputObj);

        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class OtomatikFaturaService {
    static getList(inputObj: OtomatikFaturaListIstegi) { return cagir('GetListPagingAndFilter', inputObj); }
    static exportList(inputObj: OtomatikFaturaListIstegi) { return cagir('ExportList', inputObj); }
    static getById(id: string) { return cagir('GetById', { id }); }
    static kaydet(inputObj: OtomatikFaturaKuralKaydet) { return cagir('Kaydet', inputObj); }
    static aktiflik(id: string, aktif: boolean) { return cagir('Aktiflik', { id, aktif }); }
    static sil(ids: string[]) { return cagir('Sil', { ids }); }
    static cronOnizle(cron: string | undefined, baslangicTarihi?: string, bitisTarihi?: string) { return cagir('CronOnizle', { cron, baslangicTarihi: tarihVeyaBos(baslangicTarihi), bitisTarihi: tarihVeyaBos(bitisTarihi), adet: 5 }, false); }
    static onaylayicilar() { return cagir('Onaylayicilar', {}); }
    static poNumaralari(kuralTuru: number, musteriIdleri: string[]) { return cagir('PoNumaralari', { kuralTuru, musteriIdleri }, false); }
    static firmalar() { return cagir('Firmalar', {}); }
    static kopyala(id: string, hedefCompanyId?: string) { return cagir('Kopyala', { id, hedefCompanyId }); }
    static onizle(kuralId: string, tarih?: string) { return cagir('Onizle', { kuralId, tarih: tarihVeyaBos(tarih) }); }
    static simdiCalistir(kuralId: string, tarih?: string) { return cagir('SimdiCalistir', { kuralId, tarih: tarihVeyaBos(tarih) }); }
    static calismaListesi(inputObj: OtomatikFaturaListIstegi) { return cagir('CalismaListesi', inputObj); }
    static calismaExport(inputObj: OtomatikFaturaListIstegi) { return cagir('CalismaExport', inputObj); }
    static calismaDetayi(id: string) { return cagir('CalismaDetayi', { id }); }
    static hatalilariYenidenDene(id: string) { return cagir('HatalilariYenidenDene', { id }); }
    static onayMailiniYenidenGonder(id: string) { return cagir('OnayMailiniYenidenGonder', { id }); }
    static onay(calismaId: string, onay: boolean, not?: string) { return cagir('Onay', { calismaId, onay, not }); }
}
